"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.returnof = exports.Cache = exports.IO = exports.err = exports.ok = exports.Result = exports.nothing = exports.just = exports.Maybe = exports.match = exports.Pair = exports.Box = exports.Witness = exports.Data = exports.isRecordOfOnly = exports.isRecordOf = exports.fillGet = exports.compose = exports.comp = exports.uncurry = exports.curry = exports.flip = exports.func = exports.array = exports.Map = exports.memo = exports.groupByKeys = exports.keyBy = exports.groupBy = exports.getIn = exports.get = exports.GQLPredicate = exports.isEq = exports.identity = void 0;
function identity(a) { return a; }
exports.identity = identity;
function isEq(_) {
    return Data.isObject(_) && _ !== null && Data.isFunction(_.equals) && _.equals.length === 1;
}
exports.isEq = isEq;
function GQLPredicate(gqlType, predicate) {
    predicate.gqlType = gqlType;
    return predicate;
}
exports.GQLPredicate = GQLPredicate;
function get(a) {
    return function (obj) { return obj[a]; };
}
exports.get = get;
function getIn(o) {
    var keys = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        keys[_i - 1] = arguments[_i];
    }
    var res = o;
    for (var _a = 0, keys_1 = keys; _a < keys_1.length; _a++) {
        var key = keys_1[_a];
        res = res[key];
    }
    return res;
}
exports.getIn = getIn;
exports.groupBy = variadicArity(function (f) { return function (as) { return groupByImpl(as, f); }; }, groupByImpl);
function groupByImpl(as, f) {
    var res = {};
    for (var _i = 0, as_1 = as; _i < as_1.length; _i++) {
        var a = as_1[_i];
        var key = f(a);
        var list = res[key];
        if (list) {
            list.push(a);
        }
        else {
            res[key] = [a];
        }
    }
    return res;
}
exports.keyBy = variadicArity(function (f) { return function (as) { return keyByImpl(as, f); }; }, keyByImpl);
function keyByImpl(as, f) {
    var res = {};
    for (var _i = 0, as_2 = as; _i < as_2.length; _i++) {
        var a = as_2[_i];
        var key = f(a);
        res[key] = a;
    }
    return res;
}
exports.groupByKeys = variadicArity(function (f) { return function (as) { return groupByKeysImpl(as, f); }; }, groupByKeysImpl);
function groupByKeysImpl(as, f) {
    var result = {};
    for (var _i = 0, as_3 = as; _i < as_3.length; _i++) {
        var val = as_3[_i];
        var keys = f(val);
        for (var _a = 0, keys_2 = keys; _a < keys_2.length; _a++) {
            var key = keys_2[_a];
            var prev = result[key];
            if (prev) {
                prev.push(val);
            }
            else {
                result[key] = [val];
            }
        }
    }
    return result;
}
var unevaled = {};
exports.memo = function (f) {
    var val = unevaled;
    return function () {
        if (val === unevaled) {
            val = f();
        }
        return val;
    };
};
function variadicArity(one, two) {
    function variadic() {
        if (arguments.length === 1) {
            return one(arguments[0]);
        }
        else {
            return two(arguments[0], arguments[1]);
        }
    }
    return variadic;
}
function Map(initial) {
    if (initial === void 0) { initial = {}; }
    return initial;
}
exports.Map = Map;
(function (Map) {
    Map.dataType = 'map';
    function is(_) {
        return Data.isObject(_) && _.constructor.name === 'Object';
    }
    Map.is = is;
    Map.keys = Object.keys;
    function values(_) {
        var result = [];
        var ks = Map.keys(_);
        for (var _i = 0, ks_1 = ks; _i < ks_1.length; _i++) {
            var key = ks_1[_i];
            result.push(_[key]);
        }
        return result;
    }
    Map.values = values;
    function has(_) {
        return function innerHas(key) {
            return Data.isDefined(_[key]);
        };
    }
    Map.has = has;
    function forEachImpl(map, f) {
        var keys = Object.keys(map);
        for (var _i = 0, keys_3 = keys; _i < keys_3.length; _i++) {
            var key = keys_3[_i];
            f(map[key], key);
        }
    }
    Map.forEach = variadicArity(function (f) { return function (as) { return forEachImpl(as, f); }; }, forEachImpl);
    function mapImpl(as, f) {
        var acc = {};
        forEachImpl(as, function (a, k) { return acc[k] = f(a, k); });
        return acc;
    }
    Map.map = variadicArity(function (f) { return function (as) { return mapImpl(as, f); }; }, mapImpl);
    function filterMapImpl(as, f) {
        var acc = {};
        forEachImpl(as, function (a, k) {
            var val = f(a, k);
            if (val !== undefined) {
                acc[k] = val;
            }
        });
        return acc;
    }
    Map.filterMap = variadicArity(function (f) { return function (as) { return filterMapImpl(as, f); }; }, filterMapImpl);
    Map.groupBy = variadicArity(function (f) { return function (as) { return groupByImpl(as, f); }; }, groupByImpl);
    function groupByImpl(as, f) {
        var result = {};
        forEachImpl(as, function (val) {
            var key = f(val);
            var prev = result[key];
            if (prev) {
                prev.push(val);
            }
            else {
                result[key] = [val];
            }
        });
        return result;
    }
    Map.groupByKeys = variadicArity(function (f) { return function (as) { return groupByKeysImpl(as, f); }; }, groupByKeysImpl);
    function groupByKeysImpl(as, f) {
        var result = {};
        forEachImpl(as, function (val) {
            var keys = f(val);
            for (var _i = 0, keys_4 = keys; _i < keys_4.length; _i++) {
                var key = keys_4[_i];
                var prev = result[key];
                if (prev) {
                    prev.push(val);
                }
                else {
                    result[key] = [val];
                }
            }
        });
        return result;
    }
    Map.keyBy = variadicArity(function (f) { return function (as) { return keyByImpl(as, f); }; }, keyByImpl);
    function keyByImpl(as, f) {
        var result = {};
        forEachImpl(as, function (val) {
            var key = f(val);
            result[key] = val;
        });
        return result;
    }
    Map.flatMap = variadicArity(function (f) { return function (as) { return flatMapImpl(as, f); }; }, flatMapImpl);
    function flatMapImpl(as, f) {
        var results = [];
        forEachImpl(as, function (a) {
            var bs = f(a);
            for (var _i = 0, bs_1 = bs; _i < bs_1.length; _i++) {
                var b = bs_1[_i];
                results.push(b);
            }
        });
        return results;
    }
    Map.filter = variadicArity(function (f) { return function (as) { return filterImpl(as, f); }; }, filterImpl);
    function filterImpl(as, pred) {
        var acc = {};
        forEachImpl(as, function (a, k) { if (pred(a, k)) {
            acc[k] = a;
        } });
        return acc;
    }
    Map.filterKeys = variadicArity(function (f) { return function (as) { return filterKeysImpl(as, f); }; }, filterKeysImpl);
    function filterKeysImpl(as, pred) {
        var keys = [];
        forEachImpl(as, function (a, k) {
            if (pred(a, k)) {
                keys.push(k);
            }
        });
        return keys;
    }
    Map.fold = function foldImplementation() {
        switch (arguments.length) {
            case 1:
                var a1f_1 = arguments[0];
                return function (initial) { return function (as) { return foldImpl(as, a1f_1, initial); }; };
            case 2:
                var a2f_1 = arguments[0];
                var a2i_1 = arguments[1];
                return function (as) { return foldImpl(as, a2f_1, a2i_1); };
            default:
                return foldImpl.apply(null, arguments);
        }
    };
    function foldImpl(as, f, initial) {
        var acc = initial;
        forEachImpl(as, function (a, k) { acc = f(a, acc); });
        return acc;
    }
    Map.getOrMutate = function (filler) { return function (map) { return function (key) {
        var _ = map[key];
        if (_ !== undefined) {
            return _;
        }
        var fill = filler(key);
        map[key] = fill;
        return fill;
    }; }; };
    Map.getOr = function getOrImplementation() {
        switch (arguments.length) {
            case 1:
                var a1filler_1 = arguments[0];
                return function (key) { return function (as) { return getOrImpl(as, a1filler_1, key); }; };
            case 2:
                var a2as_1 = arguments[0];
                var a2filler_1 = arguments[1];
                return function (key) { return getOrImpl(a2as_1, a2filler_1, key); };
            default:
                return getOrImpl.apply(null, arguments);
        }
    };
    function getOrImpl(as, filler, key) {
        var _ = as[key];
        return _ !== undefined ? _ : filler(key);
    }
    function entries(as) {
        return Object.keys(as).map(function (key) { return [key, as[key]]; });
    }
    Map.entries = entries;
})(Map = exports.Map || (exports.Map = {}));
var array;
(function (array) {
    array.dataType = 'array';
    array.is = Array.isArray;
    function flatten(as) {
        var res = [];
        for (var _i = 0, as_4 = as; _i < as_4.length; _i++) {
            var a = as_4[_i];
            for (var _a = 0, a_1 = a; _a < a_1.length; _a++) {
                var _ = a_1[_a];
                res.push(_);
            }
        }
        return res;
    }
    array.flatten = flatten;
    function flatMap(as, f) {
        var res = [];
        for (var i = 0; i < as.length; i++) {
            var bs = f(as[i], i);
            for (var _i = 0, bs_2 = bs; _i < bs_2.length; _i++) {
                var b = bs_2[_i];
                res.push(b);
            }
        }
        return res;
    }
    array.flatMap = flatMap;
    function intersperse(as, f) {
        var length = as.length;
        switch (length) {
            case 0: return as;
            case 1: return as;
            default: {
                var spersed = [as[0]];
                for (var i = 1; i < length; i++) {
                    spersed.push(f(i));
                    spersed.push(as[i]);
                }
                return spersed;
            }
        }
    }
    array.intersperse = intersperse;
    array.filterMap = variadicArity(function (f) { return function (as) { return filterMapImpl(as, f); }; }, filterMapImpl);
    function filterMapImpl(as, fn) {
        var bs = [];
        var length = as.length;
        for (var i = 0; i < length; i++) {
            var b = fn(as[i], i);
            if (b !== undefined) {
                bs.push(b);
            }
        }
        return bs;
    }
})(array = exports.array || (exports.array = {}));
var func;
(function (func) {
    func.dataType = 'func';
    func.is = function (_) { return typeof _ === 'function'; };
    func.lazy = function (f) { return function (a) { return function () { return f(a); }; }; };
    func.flip = function (f) { return function (b, a) { return f(a, b); }; };
    func.curry = function (f) { return function (a) { return function (b) { return f(a, b); }; }; };
    func.uncurry = function (f) { return function (a, b) { return f(a)(b); }; };
    func.compose = function (f, g) { return function (a) { return f(g(a)); }; };
    func.comp = func.compose;
    func.memoize = exports.memo;
    func.map = func.compose;
    func.precompose = func.flip(func.compose);
    func.precomp = func.precompose;
    func.contramap = func.precompose;
})(func = exports.func || (exports.func = {}));
exports.flip = func.flip;
exports.curry = func.curry;
exports.uncurry = func.uncurry;
exports.comp = func.comp;
exports.compose = func.compose;
exports.fillGet = exports.flip(func.uncurry(Map.getOrMutate));
function isRecordOf(preds) {
    return function (_) {
        try {
            var keys = Object.keys(_);
            for (var _i = 0, keys_5 = keys; _i < keys_5.length; _i++) {
                var key = keys_5[_i];
                var pred = preds[key];
                if (pred && !pred(_[key])) {
                    return false;
                }
            }
        }
        catch (error) {
            return false;
        }
        return true;
    };
}
exports.isRecordOf = isRecordOf;
function isRecordOfOnly(preds) {
    return function (_) {
        try {
            var keys = Object.keys(_);
            for (var _i = 0, keys_6 = keys; _i < keys_6.length; _i++) {
                var key = keys_6[_i];
                var pred = preds[key];
                if (!pred || !pred(_[key])) {
                    return false;
                }
            }
        }
        catch (error) {
            return false;
        }
        return true;
    };
}
exports.isRecordOfOnly = isRecordOfOnly;
// Keep your inheritance one layer deep, inherit from Data, but do not inherit
// from classes that inherit from Data.
var Data = /** @class */ (function () {
    function Data() {
    }
    // You get for free
    Data.is = function (_) { return _ instanceof Data; };
    Object.defineProperty(Data.prototype, "type", {
        get: function () { return this.constructor.dataType; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Data.prototype, "serialize", {
        get: function () { return this.constructor.serialize(this); },
        enumerable: false,
        configurable: true
    });
    Data.prototype.isValid = function () { return this.constructor.validate(this); };
    Data.prototype.equals = function (other) {
        if (other === this) {
            return true;
        }
        if (!this.constructor.is(other)) {
            return false;
        }
        var keys = Object.keys(this);
        for (var _i = 0, keys_7 = keys; _i < keys_7.length; _i++) {
            var key = keys_7[_i];
            var mine = this[key];
            var theirs = other[key];
            if (!Data.valueEquality(mine, theirs)) {
                return false;
            }
        }
        return true;
    };
    Data.valueEquality = function (a, b) {
        if (a === b || (a !== a && b !== b)) {
            return true;
        }
        if (a === null || b === null) {
            return false;
        }
        if (Data.isFunction(a) && Data.isFunction(b)) {
            return true;
        }
        if (Data.isPrimitive(a) || Data.isPrimitive(b)) {
            return false;
        }
        if (Data.isEq(a) && Data.isEq(b)) {
            return a.equals(b);
        }
        if (Data.isArray(a)) {
            if (!Data.isArray(b)) {
                return false;
            }
            if (a.length !== b.length) {
                return false;
            }
            for (var i = 0; i < a.length; i++) {
                if (!Data.valueEquality(a[i], b[i])) {
                    return false;
                }
            }
        }
        else if (Data.isObject(a)) {
            if (!Data.isObject(b) || Data.isArray(b)) {
                return false;
            }
            var akeys = Map.keys(a), bkeys = Map.keys(b);
            for (var _i = 0, akeys_1 = akeys; _i < akeys_1.length; _i++) {
                var key = akeys_1[_i];
                if (!Data.valueEquality(a[key], b[key])) {
                    return false;
                }
            }
            for (var _a = 0, bkeys_1 = bkeys; _a < bkeys_1.length; _a++) {
                var key = bkeys_1[_a];
                if (!a.hasOwnProperty(key)) {
                    return false;
                }
            }
        }
        return true;
    };
    // For value equality semantics in Immutable.js
    // It looks like v4 (coming soon?) might have a better option for this, revisit then
    Data.prototype.hashCode = function () {
        var str = this.json;
        var hash = 0, chr;
        var length = str.length;
        if (length === 0) {
            return hash;
        }
        for (var i = 0; i < length; i++) {
            chr = str.charCodeAt(i);
            hash = ((hash << 5) - hash) + chr;
            hash |= 0;
        }
        return hash;
    };
    // Serialization
    // Json
    Data.prototype.toJSON = function () {
        var ctor = this.constructor;
        return ctor.genericSerialize ? ctor.serialize(this) : [this.type, ctor.serialize(this)];
    };
    Object.defineProperty(Data.prototype, "json", {
        get: function () { return JSON.stringify(this); },
        enumerable: false,
        configurable: true
    });
    // Registering for serialization
    Data.register = function () { Witness.register(this); };
    Data.TypeKey = 'type';
    // Required override
    Data.dataType = 'Data';
    // Optional override
    Data.preds = {};
    Data.genericDeserialize = true;
    Data.json = function (_) { return JSON.stringify(_); };
    Data.jsonReviver = function (k, v) {
        if (v === null) {
            return v;
        }
        if (Data.isArray(v) && v.length === 2 && Data.isString(v[0])) {
            var wit = Witness.registry[v[0]];
            if (wit && !wit.genericSerialize) {
                return wit.deserialize(v[1]);
            }
        }
        else if (Data.isObject(v) && Data.isString(v.type)) {
            var wit = Witness.registry[v.type];
            if (wit && wit.genericSerialize) {
                return wit.deserialize(v);
            }
        }
        return v;
    };
    Data.unjson = function (_) { return JSON.parse(_, Data.jsonReviver); };
    // Dealing with things from IO, of unknown type
    Data.match = function (f) { return function (_) {
        if (Data.is(_)) {
            var match_1 = f[_.type];
            if (match_1) {
                return exports.ok(match_1(_));
            }
            else {
                return exports.err('Unmatched type ' + _.type);
            }
        }
        else {
            return exports.err('Not Data');
        }
    }; };
    // Predicates and useful functionality, attached mostly for namespacing purposes
    Data.getType = function (_) {
        if (Data.is(_)) {
            return _.type;
        }
        if (Data.isPrimitive(_)) {
            return typeof _;
        }
        if (Data.isArray(_)) {
            return array.dataType;
        }
        if (Data.isMap(_)) {
            return Map.dataType;
        }
        if (Data.isFunction(_)) {
            return func.dataType;
        }
        if (IO.is(_)) {
            return IO.dataType;
        }
        throw new Error('Cannot get type: ' + _);
    };
    Data.get = get;
    Data.getIn = getIn;
    Data.groupBy = exports.groupBy;
    Data.keyBy = exports.keyBy;
    Data.isAny = function (_) { return true; };
    Data.isEq = isEq;
    Data.isDefined = function (_) { return _ !== null && _ !== undefined; };
    Data.isPrimitive = function (_) { return typeof _ !== 'object'; };
    Data.isArray = Array.isArray;
    Data.isArrayOf = function (pred) { return function (_) {
        if (!Data.isArray(_)) {
            return false;
        }
        for (var _i = 0, _a = _; _i < _a.length; _i++) {
            var x = _a[_i];
            if (!pred(x)) {
                return false;
            }
        }
        return true;
    }; };
    Data.isObject = function (_) { return typeof _ === 'object' && _ !== null; };
    Data.isRecordOf = isRecordOf;
    Data.isRecordOfOnly = isRecordOfOnly;
    Data.isMap = Map.is;
    Data.isEmpty = function (_) { return Data.isArray(_) ? _.length === 0 : Object.keys(_).length === 0; };
    Data.first = function (_) { return Maybe.unit(Data.isArray(_) ? _[0] : Data.isMap(_) ? _[Object.keys(_)[0]] : null); };
    Data.isString = function (_) { return typeof _ === 'string'; };
    Data.isNumber = function (_) { return typeof _ === 'number'; };
    Data.isNaN = function (_) { return isNaN(_) && Data.isNumber(_); };
    Data.isInteger = function (_) { return Data.isNumber(_) && isFinite(_) && Math.floor(_) === _; };
    Data.isBool = function (_) { return typeof _ === 'boolean'; };
    Data.isFunction = func.is;
    Data.equals = Data.valueEquality;
    return Data;
}());
exports.Data = Data;
var Witness;
(function (Witness) {
    Witness.registry = {};
    var witnessPreds = isRecordOf({
        dataType: Data.isString
    });
    var validWitness = function (_) {
        if (!witnessPreds(_)) {
            return false;
        }
        // removed because of hot reload in testwatch, which erroneously triggered it
        // const existing = registry[_.dataType]
        // if (existing !== undefined && existing !== _) { return false }
        // removed to support automatic serialization
        // const hasDeconstruct = Data.isFunction(_.deconstruct)
        // const hasSerializeAndDeserialize = Data.isFunction(_.serialize) && Data.isFunction(_.deserialize)
        // if (!hasDeconstruct && !hasSerializeAndDeserialize) { return false }
        return true;
    };
    Witness.register = function (wit) {
        if (!validWitness(wit)) {
            throw new Error('Invalid data instance: ' + wit);
        }
        var fiw = wit;
        fiw.is = function (_) { return _ instanceof wit; }; // (wit as any)
        var dataType = wit.dataType, deconstruct = wit.deconstruct, serialize = wit.serialize, deserialize = wit.deserialize, preds = wit.preds;
        if (deconstruct) {
            wit.serialize = deconstruct;
            wit.deserialize = function generatedDataDeserialization(args) {
                var _a;
                return new ((_a = wit).bind.apply(_a, __spreadArrays([void 0], args)))();
            };
            fiw.genericSerialize = false;
        }
        else if (serialize && deserialize) {
            fiw.genericSerialize = false;
        }
        else {
            fiw.genericSerialize = true;
            fiw.serialize = function generatedDataSerialization(a) {
                var res = {};
                var keys = Object.keys(a);
                for (var _i = 0, keys_8 = keys; _i < keys_8.length; _i++) {
                    var key = keys_8[_i];
                    res[key] = a[key];
                }
                res.type = a.type;
                return res;
            };
            fiw.deserialize = function generatedDataDeserialization(a) {
                delete a.type;
                var res = new wit();
                var keys = Object.keys(a);
                for (var _i = 0, keys_9 = keys; _i < keys_9.length; _i++) {
                    var key = keys_9[_i];
                    res[key] = a[key];
                }
                return res;
            };
        }
        fiw.validate = preds ? isRecordOf(preds) : Data.isAny;
        Witness.registry[dataType] = fiw;
        return fiw;
    };
})(Witness = exports.Witness || (exports.Witness = {}));
var Box = /** @class */ (function (_super) {
    __extends(Box, _super);
    function Box(_) {
        var _this = _super.call(this) || this;
        _this._ = _;
        return _this;
    }
    Box.prototype.equals = function (other) {
        return other instanceof Box && Data.equals(this._, other._);
    };
    Box.dataType = 'GBox';
    Box.serialize = function (_a) {
        var _ = _a._;
        return _;
    };
    Box.deserialize = function (_) { return new Box(_); };
    return Box;
}(Data));
exports.Box = Box;
Box.register();
var Pair = /** @class */ (function (_super) {
    __extends(Pair, _super);
    function Pair(fst, snd) {
        var _this = _super.call(this) || this;
        _this.fst = fst;
        _this.snd = snd;
        return _this;
    }
    Pair.prototype.equals = function (other) {
        return other instanceof Pair && Data.equals(this.fst, other.fst) && Data.equals(this.snd, other.snd);
    };
    Pair.dataType = 'GPair';
    Pair.serialize = function (_a) {
        var fst = _a.fst, snd = _a.snd;
        return [fst, snd];
    };
    Pair.deserialize = function (_a) {
        var f = _a[0], s = _a[1];
        return new Pair(f, s);
    };
    return Pair;
}(Data));
exports.Pair = Pair;
Pair.register();
exports.match = Data.match;
var Maybe;
(function (Maybe) {
    Maybe.unit = function (a) { return a === undefined || a === null || a === Maybe.nothing ? Maybe.nothing : new Just(a); };
    Maybe.map = function (fn) { return function (mb) { return mb.map(fn); }; };
    Maybe.just = Maybe.unit;
    Maybe.is = function (_) { return _ instanceof Just || _ === Nothing; };
    Maybe.match = function (f) { return function (mb) { return mb.match(f); }; };
    Maybe.traverse = function (f) {
        return function (as) {
            if (Data.isArray(as)) {
                var bs = [];
                for (var _i = 0, as_5 = as; _i < as_5.length; _i++) {
                    var a = as_5[_i];
                    var mb = f(a);
                    if (mb.isNothing) {
                        return Maybe.nothing;
                    }
                    bs.push(mb.get);
                }
                return Maybe.just(bs);
            }
            else {
                var bs = {};
                var keys = Object.keys(as);
                for (var _a = 0, keys_10 = keys; _a < keys_10.length; _a++) {
                    var key = keys_10[_a];
                    var mb = f(as[key]);
                    if (mb.isNothing) {
                        return Maybe.nothing;
                    }
                    bs[key] = mb.get;
                }
                return Maybe.just(bs);
            }
        };
    };
    var Nothing = /** @class */ (function (_super) {
        __extends(Nothing, _super);
        function Nothing() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(Nothing.prototype, "isJust", {
            get: function () { return false; },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Nothing.prototype, "isNothing", {
            get: function () { return true; },
            enumerable: false,
            configurable: true
        });
        Nothing.prototype.unwrap = function () { throw new Error('Cannot unwrap a Nothing'); };
        Object.defineProperty(Nothing.prototype, "get", {
            get: function () { return null; },
            enumerable: false,
            configurable: true
        });
        Nothing.prototype.getOr = function (_) { return _; };
        Nothing.prototype.bind = function (fn) { return this; };
        Nothing.prototype.flatMap = function (fn) { return this; };
        Nothing.prototype.map = function (fn) { return this; };
        Nothing.prototype.match = function (_a) {
            var Nothing = _a.Nothing;
            return Nothing();
        };
        Nothing.prototype.equals = function (other) { return other === this; };
        Nothing.prototype.fold = function (f) { return identity; };
        Nothing.dataType = 'Nothing';
        Nothing.serialize = function (_) { return null; };
        Nothing.deserialize = function (_) { return Maybe.nothing; };
        return Nothing;
    }(Data));
    Maybe.Nothing = Nothing;
    Maybe.nothing = new Nothing();
    Nothing.register();
    var Just = /** @class */ (function (_super) {
        __extends(Just, _super);
        function Just(value) {
            var _this = _super.call(this) || this;
            _this.value = value;
            if (!Data.isDefined(value)) {
                throw new Error('Cannot initialize a Just with null or undefined');
            }
            return _this;
        }
        Object.defineProperty(Just.prototype, "isJust", {
            get: function () { return true; },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Just.prototype, "isNothing", {
            get: function () { return false; },
            enumerable: false,
            configurable: true
        });
        Just.prototype.unwrap = function () { return this.value; };
        Object.defineProperty(Just.prototype, "get", {
            get: function () { return this.value; },
            enumerable: false,
            configurable: true
        });
        Just.prototype.getOr = function () { return this.value; };
        Just.prototype.bind = function (fn) { return fn(this.value); };
        Just.prototype.flatMap = function (fn) { return fn(this.value); };
        Just.prototype.map = function (fn) { return Maybe.unit(fn(this.value)); };
        Just.prototype.match = function (_a) {
            var Just = _a.Just;
            return Just(this.value);
        };
        Just.prototype.equals = function (other) { return other instanceof Just ? Data.equals(this.value, other.value) : false; };
        Just.prototype.fold = function (f) {
            var _this = this;
            return function (b) { return f(_this.value, b); };
        };
        Just.dataType = 'Just';
        Just.preds = { value: Data.isDefined };
        Just.serialize = function (_) { return _.value; };
        Just.deserialize = function (_) { return new Just(_); };
        return Just;
    }(Data));
    Maybe.Just = Just;
    Just.register();
})(Maybe = exports.Maybe || (exports.Maybe = {}));
exports.just = Maybe.just;
exports.nothing = Maybe.nothing;
var Result;
(function (Result) {
    Result.unit = function (r) { return r instanceof Error ? new Err(r) : new Ok(r); };
    Result.map = function (fn) { return function (r) { return r.map(fn); }; };
    Result.ok = function (r) { return new Ok(r); };
    Result.err = function (e) { return new Err(e); };
    Result.is = function (_) { return _ instanceof Ok || _ instanceof Err; };
    Result.match = function (f) { return function (res) { return res.match(f); }; };
    Result.traverse = function (f) {
        return function (as) {
            if (Data.isArray(as)) {
                var bs = [];
                for (var _i = 0, as_6 = as; _i < as_6.length; _i++) {
                    var a = as_6[_i];
                    var rb = f(a);
                    if (rb.isErr) {
                        return rb;
                    }
                    bs.push(rb.unwrap());
                }
                return Result.ok(bs);
            }
            else {
                var bs = {};
                var keys = Object.keys(as);
                for (var _a = 0, keys_11 = keys; _a < keys_11.length; _a++) {
                    var key = keys_11[_a];
                    var rb = f(as[key]);
                    if (rb.isErr) {
                        return rb;
                    }
                    bs[key] = rb.unwrap();
                }
                return Result.ok(bs);
            }
        };
    };
    var Ok = /** @class */ (function (_super) {
        __extends(Ok, _super);
        function Ok(a) {
            var _this = _super.call(this) || this;
            _this.a = a;
            return _this;
        }
        Object.defineProperty(Ok.prototype, "isOk", {
            get: function () { return true; },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Ok.prototype, "isErr", {
            get: function () { return false; },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Ok.prototype, "get", {
            get: function () { return this.a; },
            enumerable: false,
            configurable: true
        });
        Ok.prototype.unwrap = function () { return this.a; };
        Ok.prototype.match = function (_a) {
            var Ok = _a.Ok;
            return Ok(this.a);
        };
        Ok.prototype.map = function (fn) { return new Ok(fn(this.a)); };
        Ok.prototype.bimap = function (f, g) { return new Ok(f(this.a)); };
        Ok.prototype.bind = function (fn) { return fn(this.a); };
        Ok.prototype.flatMap = function (fn) { return fn(this.a); };
        Ok.prototype.equals = function (other) { return other instanceof Ok && Data.equals(this.a, other.a); };
        Ok.prototype.fold = function (f) {
            var _this = this;
            return function (c) { return f(_this.a, c); };
        };
        Ok.dataType = 'Ok';
        Ok.preds = { a: Data.isAny };
        Ok.serialize = function (_) { return _.a; };
        Ok.deserialize = function (_) { return new Ok(_); };
        return Ok;
    }(Data));
    Result.Ok = Ok;
    Ok.register();
    var Err = /** @class */ (function (_super) {
        __extends(Err, _super);
        function Err(b) {
            var _this = _super.call(this) || this;
            _this.b = b;
            return _this;
        }
        Object.defineProperty(Err.prototype, "isOk", {
            get: function () { return false; },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Err.prototype, "isErr", {
            get: function () { return true; },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Err.prototype, "get", {
            get: function () { return this.b; },
            enumerable: false,
            configurable: true
        });
        Err.prototype.unwrap = function () { throw new Error('Cannot unwrap an err'); };
        Err.prototype.match = function (_a) {
            var Err = _a.Err;
            return Err(this.b);
        };
        Err.prototype.map = function () { return this; };
        Err.prototype.bimap = function (f, g) { return new Err(g(this.b)); };
        Err.prototype.bind = function () { return this; };
        Err.prototype.flatMap = function () { return this; };
        Err.prototype.equals = function (other) { return other instanceof Err && Data.equals(this.b, other.b); };
        Err.prototype.fold = function (f) { return identity; };
        Err.dataType = 'Err';
        Err.preds = { b: Data.isAny };
        Err.serialize = function (_) { return _.b; };
        Err.deserialize = function (_) { return new Err(_); };
        return Err;
    }(Data));
    Result.Err = Err;
    Err.register();
})(Result = exports.Result || (exports.Result = {}));
exports.ok = Result.ok;
exports.err = Result.err;
var IO = /** @class */ (function () {
    function IO(effect) {
        this.effect = effect;
    }
    IO.prototype.run = function () { return this.effect(); };
    IO.prototype.map = function (f) {
        var _this = this;
        return new IO(function () { return f(_this.run()); });
    };
    IO.prototype.bind = function (f) {
        var _this = this;
        return new IO(function () { return f(_this.run()).run(); });
    };
    IO.prototype.flatMap = function (f) {
        var _this = this;
        return new IO(function () { return f(_this.run()).run(); });
    };
    IO.prototype.equals = function (other) { return this === other; };
    IO.dataType = 'io';
    IO.pure = function (a) { return new IO(function () { return a; }); };
    IO.map = function (f) { return function (as) { return as.map(f); }; };
    IO.lift = IO.map;
    IO.of = function (f) { return function (a) { return new IO(function () { return f(a); }); }; };
    IO.is = function (_) { return _ instanceof IO; };
    IO.traverse = function (f) {
        return (function (as) {
            if (Data.isArray(as)) {
                return new IO(function () {
                    var bs = [];
                    for (var _i = 0, as_7 = as; _i < as_7.length; _i++) {
                        var a = as_7[_i];
                        bs.push(f(a).run());
                    }
                    return bs;
                });
            }
            else {
                return new IO(function () {
                    var bs = {};
                    var keys = Object.keys(as);
                    for (var _i = 0, keys_12 = keys; _i < keys_12.length; _i++) {
                        var key = keys_12[_i];
                        bs[key] = f(as[key]).run();
                    }
                    return bs;
                });
            }
        });
    };
    return IO;
}());
exports.IO = IO;
var Cache;
(function (Cache) {
    function Keyed(keyFromT) {
        if (keyFromT === void 0) { keyFromT = function (t) { return t; }; }
        return function () {
            var counter = 1;
            var byCounter = [];
            var byKey = {};
            var getId = function (t) { return byKey[keyFromT(t)]; };
            var getVal = function (id) { return byCounter[id]; };
            var include = function (t) {
                var key = keyFromT(t);
                byKey[key] = counter;
                byCounter[counter] = t;
                counter++;
            };
            return { getId: getId, getVal: getVal, include: include };
        };
    }
    Cache.Keyed = Keyed;
})(Cache = exports.Cache || (exports.Cache = {}));
function returnof(f) {
    return null;
}
exports.returnof = returnof;
//# sourceMappingURL=data.js.map